(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams-history.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams-history.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  TransactionHistoryNoTeams = _svs$arena$pages$team.TransactionHistoryNoTeams,
  TransactionHistoryList = _svs$arena$pages$team.TransactionHistoryList;
const _svs$ui$ReactForm = svs.ui.ReactForm,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option,
  ControlGroup = _svs$ui$ReactForm.ControlGroup;
const useTeams = svs.arena.shared.hooks.useTeams;
const TeamsHistory = () => {
  const _useTeams = useTeams(60),
    teamsList = _useTeams.data;
  const _React$useState = React.useState('-1'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedTeam = _React$useState2[0],
    setSelectedTeam = _React$useState2[1];
  React.useEffect(() => {
    if (teamsList.length === 1) {
      setSelectedTeam(teamsList[0].syndicateId);
    }
  }, [teamsList]);
  return React.createElement("div", {
    className: "transaction-history-container padding-xs-1 padding-sm-2"
  }, teamsList && teamsList.length === 0 && React.createElement(TransactionHistoryNoTeams, null), teamsList && teamsList.length === 1 && React.createElement("div", {
    className: "f-content margin-bottom-1 padding-left-1"
  }, teamsList[0].syndicateName), teamsList && teamsList.length > 1 && React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    className: "margin-bottom-1",
    onChange: e => setSelectedTeam(e.currentTarget.value),
    v2: true,
    value: selectedTeam
  }, React.createElement(Option, {
    disabled: true,
    key: -1,
    value: "-1"
  }, "V\xE4lj ett lag"), teamsList && teamsList.map(item => {
    var _item$syndicateId;
    return React.createElement(Option, {
      key: item.syndicateId,
      value: (_item$syndicateId = item.syndicateId) === null || _item$syndicateId === void 0 ? void 0 : _item$syndicateId.toString()
    }, item.syndicateName);
  }))), selectedTeam > 0 && React.createElement(TransactionHistoryList, {
    selectedTeam: selectedTeam
  }));
};
svs.arena.pages.teams.TeamsHistory = TeamsHistory;

 })(window);